export default __webpack_public_path__ + "static/media/l41.57e5be5a.png";